function isCanadaCountry(country) {
  if (!country) return true; // default to Canada
  const countryObj = !!country && typeof country.toJS === 'function' ? country.toJS() : country;
  const name = countryObj.label || countryObj.value || '';
  return name.toLowerCase() === 'canada';
}

function mapCanadaBankFields(data) {
  const bankBranchCode = data.institutionNumber
    ? `${data.institutionNumber || ''}${data.bsbNumber || ''}`
    : data.bsbNumber || '';
  return {
    bankAccountName: data.accountHolder,
    bankAccountNumber: data.accountNumber,
    bankBranchName: data.branch,
    bankBranchCode,
    bankName: data.nameOfBank,
    bankCodeType: 'Bank Code',
  };
}

function mapTrawickBankFields(data) {
  const countryDetails = !!data.country && typeof data.country.toJS === 'function' ? data.country.toJS() : data.country;
  return {
    bankName: data.bank,
    bankBranchCode: data.bankTypeCode === 'SWIFT Code' ? data.swiftCode : data.bankTypeCode === 'Bank Code' ? data.bankCodeOrRoutingNumber : '',
    bankBranchName: data.bankBranch,
    bankRoutingNumber: data.bankCodeOrRoutingNumber,
    bankAccountName: data.bankAccountName,
    bankAccountNumber: data.bankAccountNumber,
    bankCodeType: data.bankTypeCode,
    bankAddress: data.bankAddress,
    bankPostcode: data.bankPostcode,
    bankSuburbOrCity: data.bankSuburbOrCity,
    IBAN: data.bankTypeCode === 'IBAN' ? data.iban : null,
    fBankCountry: countryDetails ? countryDetails.id : null,
  };
}

function mapCheckFields(data) {
  return {
    creditorName: data.firstName,
    creditorSurname: data.lastName,
    creditorFullName: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
    physicalAddress1: data.addressLine1,
    physicalAddress2: data.addressLine2,
    physicalAddress3: data.city,
    physicalAddress4: data.state,
    physicalCode: data.postalZipCode,
    titleID: data.title,
    cellNumber: data.mobile,
  };
}

function mapToParentSection(data) {
  const countryDetails = !!data.country && typeof data.country.toJS === 'function' ? data.country.toJS() : data.country;
  const isCanada = isCanadaCountry(data.country);
  const isCheckPayment = data.isCheckPayment === true;

  // Base fields (GST, other insurance - always included)
  const baseFields = {
    ABNNumber: data.abn,
    gstRegistered: data.registerForGSTPurpose,
    gstPercentageClaimed: data.percentageOfGST,
    claimInputTaxCredit: data.claimITC,
    country: countryDetails ? countryDetails.id : null,
    creditorExtension: {
      payToEntity: data.paymentTo,
      paymentVia: data.paymentVia || 'EFT',
    },
  };

  // Bank fields depend on country selection and check payment
  let bankFields = {};
  if (!isCheckPayment) {
    bankFields = isCanada ? mapCanadaBankFields(data) : mapTrawickBankFields(data);
  }

  // Check/address fields when check payment is selected
  const checkFields = isCheckPayment ? mapCheckFields(data) : {};

  return {
    ...baseFields,
    ...bankFields,
    ...checkFields,
  };
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section1.otherInsurance',
      answer: data.otherInsurance,
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.provideDetails',
      answer: data.provideDetails,
      claimTypeCode: claimCode,
    },
  ];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepAppsureBankDetailsDataMapper.js